import React from "react";
import { makeStyles, ButtonBase } from "@material-ui/core";
import { useRouter } from "next/router";

import Arrow from "../../assets/arrowBack.svg";

export default function FunnelSubHeader({ cta }) {
  const classes = useStyle();
  const router = useRouter();
  if (cta) {
    return (
      <div className={classes.container}>
        <Arrow className={classes.icon} />
        {cta}
      </div>
    );
  }
  return (
    <div className={classes.container}>
      <Arrow className={classes.icon} />
      <ButtonBase className={classes.text} onClick={() => router.back()}>
        Continuer vos achats
      </ButtonBase>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
  icon: {
    width: 7,
    height: 10,
  },
  text: {
    color: theme.palette.text.disabled,
    marginLeft: theme.spacing(2),
    fontWeight: "bold",
    fontSize: 13,
  },
}));
